<template>
  <div class="ImportFileFormComponent">

    <b-form >

      <b-form-group id="input-group-Name" :label="lang.label_Name" label-for="input-2">
        <b-form-file
            v-model="form.file"
            :state="Boolean(form.file)"
            :placeholder= lang.placeholder_file
            drop-placeholder="Drop file here..."
            class="import-file"
            
            size="sm"

        ></b-form-file>

        
      </b-form-group>

      

    </b-form>
  </div>
</template>

<script>


export default {
  name: "ImportFileFormComponent",
  components: {



  },
  props:{
    lang: Object
  },
  data () {
    return {
        //file: null
      form: {

        file: null,
               
        
      },
      inputStatus: null,
      
    }
  },
  computed: {
    
    
  },
  created() {


  },
  updated(){
    
    this.$store.dispatch(this.$store.getters.sectionPrefix + "_setVariantFolderForm", this.form)
    
  },
  methods: {

  }
}
</script>
<style lang="scss">
  .ImportFileFormComponent{

  }



</style>



// WEBPACK FOOTER //
// src/components/shared/ImportFileFormComponent.vue